import { Col, Drawer, Row, Select, Space } from "antd"
import React, { useEffect, useState } from "react"
import Number from "../../chart/number/Number";
import { PhoneTwoTone, ClockCircleTwoTone } from "@ant-design/icons";
import ScatterPlot from "../../chart/scatterPlot/ScatterPlot";
import DateRangePicker from "../../../system/dateRangePicker/DateRangePicker";
import { useDispatch, useSelector } from "react-redux";
import { Moment } from "moment";
import { RootState } from "../../../../model/rootReducer";
import { getTargetedEventsAction } from "../../../../business/actions/analyticsActions";
import Loader from "../../../system/loader/Loader";
import { createLoadingSelector } from "../../../../business/selectors/loadingSelectors";
import { AnalyticsDate, CallPerf } from "../../../../model/analytics/types";
import AnalyticsDrawer from "../analyticsDetails/AnalyticsDetails";
import { formatEventCluster, getEventAverageTime } from "../../../../helpers/analyticsHelper";
import { AnalyticsTooltip } from "../analyticsTooltip/AnalyticsTooltip";
import { toDatePicker } from "../../../../helpers/dateFormatHelper";
const { Option } = Select;

type AnalyticsByEventProps = {
    globalPerf: CallPerf;
    dates: AnalyticsDate
}

const AnalyticsByEvent: React.FunctionComponent<AnalyticsByEventProps> = ({
    globalPerf,
    dates
}) => {
    const eventPerf = useSelector(
        (state: RootState) => state.analytics.eventPerf
    )
    const dispatch = useDispatch()
    const loadingSelector = createLoadingSelector([
        'GET_TARGETED_EVENTS',
    ])
    const isFetching = useSelector((state: RootState) => loadingSelector(state))
    const selectedBotId = useSelector((state: RootState) => state.bot.selectedBot)
    const [selectedEvent, setSelectedEvent] = useState(Object.keys(globalPerf.statistics)[0])
    const [item, setItem] = useState<any>([])
    const [visible, setVisible] = useState(false)
    const [selectedCluster, setSelectedCluster] = useState<any>();
    const [filter, setFilter] = useState({
        startDate: dates.startDate,
        endDate: dates.endDate,
    })

    const onIntervalChange = (startDate: Moment, endDate: Moment) => {
        setFilter({
            ...filter,
            startDate: startDate,
            endDate: endDate,
        })
    }

    const showDrawer = (event: any) => {
        setVisible(true)
        setSelectedCluster(event.data);
    }
    const onClose = () => {
        setVisible(false)
    }

    useEffect(() => {
        if (selectedBotId) {
            setItem("")
            Object.entries(eventPerf.statistics).map(([key, val]) => {
                setItem((old: any) => [...old, <Option value={key}>{key}</Option>])
            });
        }
    }, [eventPerf])

    useEffect(() => {
        if (selectedBotId) {
            dispatch(getTargetedEventsAction.request({
                startDate: toDatePicker(filter.startDate),
                endDate: toDatePicker(filter.endDate),
                event: selectedEvent
            }));
        }
    }, [selectedBotId, selectedEvent, filter])

    const onEventChange = (event: any) => {
        setSelectedEvent(event)
    }

    return (
        <Loader isLoading={isFetching}>
            <Space>
                <DateRangePicker
                    startDate={filter.startDate}
                    endDate={dates.endDate}
                    onChange={onIntervalChange}
                />
                <Select
                    showSearch
                    style={{ width: 200 }}
                    onChange={onEventChange}
                    defaultValue={Object.keys(globalPerf.statistics)[0]}
                    optionFilterProp="children"
                >
                    {item}
                </Select>

            </Space>
            <Row style={{ marginTop: "16px" }} gutter={[16, 16]}>
                <Col span={6}>
                    <Number
                        color={{
                            "0%": "#108ee9",
                            "100%": "#ab2cf4"
                        }}
                        title="Nombre d'appels"
                        text={eventPerf.callNumber.toString()}
                        percent={100}
                        Icon={
                            <PhoneTwoTone
                                style={{ fontSize: "30px" }}
                                twoToneColor="#ab2cf4"
                            />
                        }
                    />
                </Col>
                <Col span={6}>
                    <Number
                        color={{
                            "0%": "#3426D1",
                            "100%": "#7049E6"
                        }}
                        title="Durée moyenne de l'événement"
                        text={getEventAverageTime(eventPerf.statistics, selectedEvent)?.toString()}
                        subText="ms"
                        percent={100}
                        Icon={
                            <ClockCircleTwoTone
                                style={{ fontSize: "30px" }}
                                twoToneColor="#7049E6"
                            />
                        }
                    />
                </Col>
                <Col span={6}>
                    <Number
                        color={{
                            "0%": "#E03D5D",
                            "100%": "#E6397E"
                        }}
                        title="Nombre de potentiels incidents"
                        text={eventPerf.incidentNumber.toString()}
                        percent={100}
                        Icon={
                            <PhoneTwoTone
                                style={{ fontSize: "30px" }}
                                twoToneColor="#E03D5D"
                            />
                        }
                    />
                </Col>
            </Row>
            <Col >
                {eventPerf.clusters.length > 0 &&
                    <ScatterPlot data={formatEventCluster(eventPerf.clusters)} title={selectedEvent} colors={"#69C0FF"}
                        legends={["durée moyenne", "nombre d'événements"]} tooltip={AnalyticsTooltip} showDrawer={showDrawer} />}
            </Col>
            <Drawer
                title={`${selectedEvent} : ${selectedCluster?.range.minMilliseconds} - ${selectedCluster?.range.maxMilliseconds} ms `}
                placement="right"
                closable={false}
                onClose={onClose}
                visible={visible}
                width={500}
            >
                <AnalyticsDrawer data={selectedCluster} visible={visible} />
            </Drawer>
        </Loader>
    )
}

export default AnalyticsByEvent
